import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
 return (
  <section id='contact' className='section contact'>
   <div className='container'>
    <div className='section-header animate-fade-in-up'>
     <h2 className='section-title'>Contact Us</h2>
     <p className='section-subtitle'>
      Get in touch with us for professional accounting services. We're here to
      help with your financial needs.
     </p>
    </div>

    <div className='contact-content'>
     <div className='contact-info animate-fade-in-left'>
      <div className='contact-item hover-lift delay-1'>
       <div className='contact-details'>
        <h3>Address</h3>
        <p>
         707 S Grady Way Suite 600
         <br />
         Renton, WA 98057
        </p>
       </div>
      </div>

      <div className='contact-item hover-lift delay-2'>
       <div className='contact-details'>
        <h3>Phone</h3>
        <p>
         <a href='tel:206-377-9501'>206-377-9501</a>
        </p>
       </div>
      </div>

      <div className='contact-item hover-lift delay-3'>
       <div className='contact-details'>
        <h3>Book an appointment with Vi Le, CPA</h3>
        <p>We currently offering virtual appointment only</p>
        <a
         href='https://calendly.com/vyle82/virtually-meeting'
         style={{ color: '#fff' }}
         target='_blank'
         rel='noopener noreferrer'
         className='btn btn-primary btn-spacing'
        >
         Book Virtual Meeting
        </a>
       </div>
      </div>

     </div>
    </div>
   </div>
  </section>
 );
};

export default Contact;
